const isSchneiderUser = (email) => {
  if (!email || typeof email !== 'string' || !email.includes('@')) {
    return false
  }
  const domain = email.split('@')[1]
  const schneiderDomains = ['se.com', 'non.se.com', 'schneider-electric.com', 'non.schneider-electric.com']
  return schneiderDomains.includes(domain)
}

// Centralized dataLayer push function to avoid repetition
const pushToDataLayer = (payload) => {
  window.dataLayer = window.dataLayer || [] // Ensure dataLayer exists
  window.dataLayer.push(payload)
}

// Get environment safely
const getEnvironment = () => {
  if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV) {
    return process.env.NODE_ENV
  }
  return 'Unknown'
}

const sendPageViewEvent = (pageTopCategory, category='', subCategory = '') => {
  pushToDataLayer({
    event: 'page_view',
    from_web_view: true,
    page_category: category,
    page_language: 'en',
    page_sub_category: subCategory,
    page_title: document.title,
    page_top_category: pageTopCategory,
    template: pageTopCategory,
    virtual_page_view: false,
    digital_platform: 'EMB',
    digital_platform_country:sessionStorage.getItem('userCountry'),
    environment: getEnvironment(),
  })
}



const sendItemClickEvent = (selectedOption, selectedLocation) => {
  pushToDataLayer({
    event: 'item_clicked',
    selected_option: selectedOption,
    selected_location: selectedLocation,
  })
}


const sendNavClickEvent = (type, category) => {
  pushToDataLayer({
    event: 'menu_click',
    menu_type: type,
    menu_category_1: category,
  })
}


const sendLoginEvent = (user) => {
  pushToDataLayer({
    event: 'login',
    is_schneider_employee: isSchneiderUser(user.email),
    is_test_user: false,
    federated_id: null,
    user_type: isSchneiderUser(user.email) ? 'SE' : 'Non-SE',
  })
}


const sendCallToActionEvent = (location, name,category,link=null) => {
  pushToDataLayer({
    event: 'cta_click',
    cta_location: location,
    cta_name: name,
    cta_link: link,
    cta_category: category,
  })
}

const sendCommonEvent = (data) => {

    pushToDataLayer(data)
  }


export {
  sendPageViewEvent,
  sendItemClickEvent,
  sendNavClickEvent,
  sendLoginEvent,
  sendCallToActionEvent,
  sendCommonEvent
}
